<div class="flex justify-content-end">
    <button mat-mini-fab type="submit" (click)="onEdit()"
        color="primary" matTooltip="Edit Catalog" aria-label="Edit Catalog" class="mx-1 glow-button">
        <mat-icon>edit</mat-icon>
    </button>
</div>
